<template>
  <Modal v-model="visible" title="修改费用" width="1200" :mask-closable="false" :footer-hide="true" class="my-modal top" ref="modal">
    <div class="tips">
      <span>*修改费率后增加或减少的点位将会留给本机构。</span>
      <span>*修改后，所有下级机构展示出来的总费率会自动变更(净收入不会变更)</span>
    </div>
    <Form :model="formData" ref="infoFormRef" class="page-form less" :label-width="110">
      <div class="">
        <FormItem label="保单号：" class="form-item" style="width: 25%">
          <span>{{ formData.policyNo }}</span>
        </FormItem>

        <FormItem label="产品名称：" class="form-item" style="width: 25%">
          <span>{{ formData.productName }}</span>
        </FormItem>

        <FormItem label="险种名称：" class="form-item" style="width: 50%">
          <span>{{ formData.insuranceName }}</span>
        </FormItem>
      </div>

      <div class="">
        <FormItem label="保障期：" class="form-item" style="width: 25%">
          <span>{{ formData.guaranteeDesc }}</span>
        </FormItem>

        <FormItem label="交费期：" class="form-item" style="width: 25%">
          <span>{{ formData.payDesc }}</span>
        </FormItem>

        <FormItem label="保单年度：" class="form-item" style="width: 25%">
          <span>{{ formData.commissionIndex }}</span>
        </FormItem>

        <FormItem label="交费期次：" class="form-item" style="width: 25%">
          <span>{{ formData.commissionPeriods }}</span>
        </FormItem>
      </div>

      <div class="">
        <FormItem label="实收保费：" class="form-item" style="width: 25%">
          <span>{{ formData.fee }}</span>
        </FormItem>

        <FormItem label="费用归属：" class="form-item" style="width: 25%">
          <span>{{ formData.owerName }}</span>
        </FormItem>

        <FormItem label="费用类型：" class="form-item" style="width: 50%">
          <span v-if="formData.owerType == 2 && (formData.commissionType == 1 || formData.commissionType == 3)">团队长基础管理费</span>
          <span v-else-if="formData.owerType == 3 && (formData.commissionType == 1 || formData.commissionType == 3)">基础费用</span>
          <span v-else-if="formData.commissionType == 2 || formData.commissionType == 4">限时加费</span>
          <span v-else-if="formData.commissionType == 5 && formData.owerType == 3">后置费用</span>
          <span v-else-if="formData.commissionType == 5 && formData.owerType == 2">团队长后置管理费</span>
        </FormItem>
      </div>

      <div>
        <FormItem
          :label-width="100"
          label="费率修改为"
          prop="originCommission"
          class="form-item full"
          style="width: 50%"
          :rules="$units.formRule.required('请输入费率', 'change', 'number')"
        >
          <InputNumber v-model="formData.originCommission" @on-change="countCommissionPrice" :min="0" placeholder="请输入" style="width: 70%"></InputNumber>
          <span class="unit">%</span>
          <Poptip
            trigger="hover"
            placement="top-start"
            :offset="-24"
            transfer-class-name="my-poptip"
          >
            <span class="tip-icon">?</span>
            <div slot="content">
              <span>继承单修改费用时，需填写续期继承比例折算前的费率</span>
            </div>
          </Poptip>
        </FormItem>
        <FormItem label="续期继承比例：" prop="extendRate" class="form-item" style="width: 40%" v-if="formData.extendRate">
          <span>{{ formData.extendRate }}</span>
          <span class="unit">%</span>
        </FormItem>
      </div>

      <div>
        <FormItem label="费用修改为" prop="commissionPrice" class="form-item" style="width: 50%">
          <span>{{ formData.commissionPrice }}</span>
          <span class="unit">元</span>
        </FormItem>
      </div>
    </Form>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="commission">
          <span :class="{ 'red': row.isChangeCommission == '1' }">{{ row.commission ? row.commission + '%' : '-' }}</span>
        </template>

        <template slot-scope="{ row }" slot="netCommission">
          <span :class="{ 'red': row.isChangeNetCommission == '1' }">{{ row.netCommission ? row.netCommission + '%' : '-' }}</span>
        </template>
      </Table>
    </div>

    <div class="ivu-modal-footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      formData: {
        originCommission: null
      },
      oldOriginCommission: '',
      listLoading: false,
      tableData: [],
      total: 0,
      columns: [
        {
          title: '服务费归属',
          align: 'center',
          key: 'owerName',
          minWidth: 100
        },
        {
          title: '归属人类型',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let owerType = params.row.owerType;
            let levelCode = params.row.levelCode;
            if (owerType == 1) {
              if (levelCode == 10001) {
                return <span>商户</span>;
              } else if (levelCode == 10002) {
                return <span>一级机构</span>;
              } else if (levelCode == 10003) {
                return <span>二级机构</span>;
              } else if (levelCode == 10004) {
                return <span>三级机构</span>;
              } else if (levelCode == 10005) {
                return <span>四级机构</span>;
              }
            } else if (owerType == 2) {
              return <span>团队长</span>;
            } else if (owerType == 3) {
              return <span>业务员</span>;
            }
          }
        },
        {
          title: '服务费比例',
          align: 'center',
          minWidth: 100,
          slot: 'commission',
          renderHeader: (h, params) => {
            return (
              <div>
                <span>服务费比例</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>如果是有后置费用的产品，此处服务费比例和净费率都是发放的那部分的</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '净费率',
          align: 'center',
          minWidth: 100,
          slot: 'netCommission'
        },
        {
          title: '收入(元)',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 120
        },
        {
          title: '剩余收入(元)',
          align: 'center',
          key: 'netIncome',
          minWidth: 120
        }
      ]
    };
  },

  methods: {
    open(row) {
      this.visible = true;
      row.originCommission = Number(row.originCommission);
      this.formData = JSON.parse(JSON.stringify(row));
      this.oldOriginCommission = row.originCommission;
      this.getList();
    },

    countCommissionPrice(value) {
      if (!value && value != 0) {
        return;
      }
      let num
      if(this.formData.extendRate){
        num = (value/100 * this.formData.extendRate * Number(this.formData.fee)) / 100;
      }else{
        num = (value * Number(this.formData.fee)) / 100;
      }
      this.$set(this.formData, 'commissionPrice', Number(num.toFixed(2)));
      this.getList();
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/getParentLogs',
        type: 'GET',
        data: {
          logId: this.formData.commissionLogId,
          oldNetCommission: this.oldOriginCommission,
          newNetCommission: this.formData.originCommission
        }
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    ok() {
      this.$refs.infoFormRef.validate().then(isok => {
        if (!isok) {
          return;
        }
        let data = {
          id: this.formData.id,
          commission: this.formData.originCommission,
          topNetCommission: this.tableData[0].originCommission
        };
        this.$http({
          url: '/buz/userSettlementData/changeCommission',
          type: 'POST',
          data
        }).then(res => {
          this.visible = false;
          this.$notice.success('操作成功');
          this.$emit('success');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-body {
  max-height: 87vh !important;
}
.tips {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  span {
    margin-bottom: 2px;
    color: #ceaf9b;
  }
}
.form-item {
  .unit {
    margin-left: 10px;
    font-size: 14px;
  }
}
.red {
  color: rgb(240, 58, 58);
}
.tip-icon {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #000;
  color: #000;
  display: inline-block;
  text-align: center;
  line-height: 15px;
  margin-left: 5px;
  font-size: 12px;
  cursor: pointer;
  top: 50%;
}
</style>
